import { ProjectTableDataType } from '../ProjectTable/types';
import { GridRowId, GridSelectionModel } from '@mui/x-data-grid';

const condition = (tableItem: ProjectTableDataType[number], item: GridRowId) =>
  'id' in tableItem ? tableItem.id !== undefined && item === tableItem.id : undefined;

export const getDataForSubmission = (
  tableData: ProjectTableDataType,
  selectedRows: GridSelectionModel,
  keepSelectedOrder: boolean = false,
): ProjectTableDataType => {
  if (keepSelectedOrder) {
    return selectedRows
      .map((selectedId) => tableData.find((item) => condition(item, selectedId)))
      .filter((item): item is ProjectTableDataType[number] => item !== undefined);
  }

  return tableData?.filter((tableItem) => selectedRows?.find((item) => condition(tableItem, item)) !== undefined);
};
